export const ProductFillMultiagent = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect
      height="12"
      width="12"
      fill="currentColor"
      fillOpacity="0.6"
      rx="2"
      transform="rotate(45 8.48438 3.5)"
      x="8.48438"
      y="3.5"
    />
    <rect height="12" width="12" fill="currentColor" rx="2" transform="rotate(45 15.5098 3.5)" x="15.5098" y="3.5" />
  </svg>
);
